<template>
    <div>

        <div v-if="isEditor && isVisible" :style="style"
             id="colorPickerElement" @mousedown="stopMousedownPropagation">

            <p style="margin-bottom: 15px">Truck Order No.: {{truckOrder.truckOrderNumber}}</p>

            <div v-if="value === Constants.internalStatus.waitingForDeparture" style="float: right">
               <template v-if="!truckOrder.orderDetailsArr.length">
                   <p style="color: red;margin-right: 100px">No Orders assigned to it !</p>
               </template>
                <template v-else-if="!truckOrder.ewayBillNo">
                    <p style="color: red;margin-right: 100px">Please enter Eway Bill number</p>
                </template>
               <template v-else>
                   <Button @click.stop="onWayToDropCityWarehouse(truckOrder.id, 'loader1')" :loading="loader1">
                       <span v-if="!loader1">Depart</span>
                       <span v-else>Loading...</span>
                   </Button>
               </template>

                <template v-if="errMessages.length">
                    <p style="margin:5px 0px">The Following Orders are still not in <i>'Waiting For Departure'</i> stage</p>
                    <ul style="color: red; margin: 10px">
                        <li v-for="(err, index) in errMessages" :key="index">{{err}}</li>
                    </ul>
                </template>

            </div>

            <div v-if="value === Constants.internalStatus.onTheWayToDropCityWarehouse" style="float: right">
                <Button @click.stop="onAtDestinationCityWarehouse(truckOrder.id, 'loader1')" :loading="loader1">
                    <span v-if="!loader1">Reached Destination City</span>
                    <span v-else>Loading...</span>
                </Button>
                <template v-if="errMessages.length">
                    <p style="margin:5px 0px">The Following Orders are still not in <i>'On The Way To Drop City Warehouse'</i> stage</p>
                    <ul style="color: red; margin: 10px">
                        <li v-for="(err, index) in errMessages" :key="index">{{err}}</li>
                    </ul>
                </template>

            </div>

            <div v-if="value === Constants.internalStatus.atDestinationCityWarehouse" style="float: right">
                <Button @click.stop="completeTruckOrder(truckOrder.id)" :loading="loader1">
                    <span v-if="!loader1">Complete</span>
                    <span v-else>Loading...</span>
                </Button>
            </div>

        </div>

        <!--<div v-if="isRenderer" style="text-align: center" :class="cellProperties.readOnly?'cell-readonly':''">-->
            <!--<template v-if="$parent.$parent.$parent.truckOrders[row]">-->
                <!--{{$parent.$parent.$parent.truckOrders[row].InternalStatus?-->
                  <!--$parent.$parent.$parent.truckOrders[row].InternalStatus.name:''}}</template>-->
        <!--</div>-->

    </div>
</template>

<script>
    import {BaseEditorComponent} from '@handsontable/vue'
    import {Constants} from "../../Constants/Constant"
    import {mapInternalStatus} from "../ExcelFormattedOrders/Settings"
    import {generate_UPDATE_ORDER_DATA} from "../../graphql/mutations/orders"
    import {VERIFY_ORDERS_BY_TRUCK_ORDER_ID_AND_STAGE_ID, UPDATE_ORDERS_AND_TRUCKORDER_STATUS_USING_TRUCK_ORDER_ID}
            from "../../graphql/queries/truckOrders"
    import moment from "moment";

    export default {
        name: "ActionPopup",
        extends: BaseEditorComponent,
        data:function () {
            return{
                Constants: Constants,
                userObj: JSON.parse(localStorage.getItem('tatkalorri')).userObj,
                mapInternalStatus: mapInternalStatus,
                truckOrder: null,
                hotInstance: null,
                TD: null,
                row: null,
                col: null,
                prop: null,
                originalValue: null,
                value: '',
                cellProperties: null,
                isVisible: false,
                isEditor: null,
                isRenderer: null,
                editorElement: null,
                style: {
                    position: "absolute",
                    padding: "15px",
                    background: "#fff",
                    zIndex: 999,
                    border: "1px solid #000",
                    left: "0px",
                    top: "0px"
                },
                loader1: false,
                loader2: false,
                errMessages: [],
                ewayBillNo: ''
            }
        },
        methods:{
            stopMousedownPropagation: function(e) {
                e.stopPropagation();
            },
            prepare: function(row, col, prop, td, originalValue, cellProperties) {
                BaseEditorComponent.options.methods.prepare.call(this, row, col, prop, td, originalValue, cellProperties);
                const tdPosition = td.getBoundingClientRect();

                this.style.left = tdPosition.left + window.pageXOffset + 'px';
                this.style.top = tdPosition.top + window.pageYOffset + 'px';
            },
            open: function() {
                this.isVisible = true
                let screen = this.$parent.$parent.$parent.screen
                let truckOrdersVariable = screen + '_truckOrders'
                let pRow = this.hotInstance.toPhysicalRow(this.row)                             //When accessing original array
                this.truckOrder = this.$parent.$parent.$parent[truckOrdersVariable][pRow]

                if(this.value === Constants.internalStatus.waitingForDeparture||
                    this.value === Constants.internalStatus.onTheWayToDropCityWarehouse){
                    this.errMessages = []
                }
            },
            focus: function() {
                this.isVisible = true;
            },
            close: function() {
                this.isVisible = false;
            },
            setValue: function(value) {
                this.value = value;
            },
            getValue: function() {
                return this.value;
            },
            onWayToDropCityWarehouse(truckOrderId){
                let stageId = Constants.internalStatus.waitingForDeparture
                let updateBy_stageId = Constants.internalStatus.onTheWayToDropCityWarehouse
                this.verifyOrdersByTruckOrderIdAndStageId(truckOrderId, stageId, this.updateOrdersStatusUsingTruckOrderId, updateBy_stageId)
            },
            onAtDestinationCityWarehouse(truckOrderId){
                let stageId = Constants.internalStatus.onTheWayToDropCityWarehouse
                let updateBy_stageId = Constants.internalStatus.atDestinationCityWarehouse
                this.verifyOrdersByTruckOrderIdAndStageId(truckOrderId, stageId, this.updateOrdersStatusUsingTruckOrderId, updateBy_stageId)
            },
            async verifyOrdersByTruckOrderIdAndStageId(truckOrderId, stageId, callback, updateBy_stageId){
                this.loader1 = true
                let response = await this.$apollo.query({
                    query: VERIFY_ORDERS_BY_TRUCK_ORDER_ID_AND_STAGE_ID,
                    fetchPolicy: 'network-only',
                    variables: {
                        truckOrderId: truckOrderId,
                        stageId: stageId
                    }
                })
                if(response.data.orders.length){
                    this.errMessages = response.data.orders.map((obj) => obj.orderNumber)
                    this.loader1 = false
                }else{
                    callback(truckOrderId, updateBy_stageId)
                }
            },
            async updateOrdersStatusUsingTruckOrderId(truckOrderId, updateBy_stageId){
                let response = await this.$apollo.mutate({
                    mutation: UPDATE_ORDERS_AND_TRUCKORDER_STATUS_USING_TRUCK_ORDER_ID,
                    variables: {
                        truckOrderId: truckOrderId,
                        stageId: updateBy_stageId,
                        lastStageUpdatedOn : moment().format(),
                        lastStageUpdatedBy : this.userObj.user.id
                    }
                })
                if(response.data){
                    this.loader1 = false
                    this.$Message.success('Multiple Orders updated successfully!')
                    this.close()
                    this.finishEditing()
                }
            },
            completeTruckOrder(id){
                let obj = {status: 'Completed'}
                this.updateRecord(id, obj, 'truckOrders', 'loader1')
            },
            async updateRecord(id, obj, table, loaderStr){
                this[loaderStr] = true
                let response = await this.$apollo.mutate({
                    mutation: generate_UPDATE_ORDER_DATA(table),
                    variables: { id: id, obj: obj}
                })
                if(response.data){
                    this.$Message.success('Order updated successfully!')
                    this[loaderStr] = false
                    this.close()
                    this.finishEditing()
                }
            },
        },
        created(){}
    }
</script>

<style scoped>
    /deep/ .ivu-select-item{
        padding: 0px 0px;
    }
    /deep/ .ivu-select-item-div{
        width: 100%;
        padding: 7px 16px;
    }
</style>
